"use client";

import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { BreadcrumbsWrapper } from "@/styles/product";
import SafeLink from "@/components/SafeLink";
import { useTranslation } from "@/i18n/client";

interface BreadcrubProps {
  category1Id: number;
  category2Id: number;
  category3Id: number;
  category1Name: string;
  category2Name: string;
  category3Name: string;
  title: string;
}

export default function BasicBreadcumbs(props: BreadcrubProps) {
  const { category1Id, category2Id, category3Id, category1Name, category2Name, category3Name, title } = props;
  const { t } = useTranslation()
  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.preventDefault();
  };
  return (
    <BreadcrumbsWrapper role="presentation" onClick={handleClick}>
      <Breadcrumbs
        aria-label="breadcrumb"
        sx={{
          "& .MuiBreadcrumbs-li:last-child": {
            flex: 1,
            width: 0,
          },
          "& .MuiBreadcrumbs-li:last-child .MuiTypography-root": {
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
          "& .MuiBreadcrumbs-li": {
            flexShrink: 0,
            minWidth: 0,
          },
          "&": {
            flex: 1,
            overflowX: "hidden",
            textOverflow: "ellipsis",

            whiteSpace: "nowrap",
          },
          "& .MuiBreadcrumbs-ol": {
            flexWrap: "nowrap",
          },
          "& .cate-link": {
            "&:hover": {
              color: "var(--dp-hover-state-color)",
              textDecoration: "none",
              cursor: "pointer",
            },
          },
        }}
      >
        <SafeLink className="cate-link" color="inherit" href={`/`}>{t("common.pageName.home")}</SafeLink>
        <SafeLink className="cate-link" color="inherit" href={`/s?b1=${category1Id}`}>
          {category1Name}
        </SafeLink>
        <SafeLink className="cate-link" color="inherit" href={`/s?b1=${category1Id}&b2=${category2Id}`}>
          {category2Name}
        </SafeLink>
        <SafeLink className="cate-link" color="inherit" href={`/s?b1=${category1Id}&b2=${category2Id}&b3=${category3Id}`}>
          {category3Name}
        </SafeLink>
        <Typography sx={{ color: "text.primary" }}>{title}</Typography>
      </Breadcrumbs>
    </BreadcrumbsWrapper>
  );
}
